export const US_COUNTRY_CODE = 'US';
export const CANADA_COUNTRY_CODE = 'CA';
export const UNITED_KINGDOM_COUNTRY_CODE = 'GB';
export const CALIFORNIA_REGION_CODE = 'CA';
export const MINNESOTA_REGION_CODE = 'MN';
export const NEW_YORK_REGION_CODE = 'NY';
export const ISRAEL_COUNTRY_CODE = 'IL';
export const NORWAY_COUNTRY_CODE = 'NO';
export const AUSTRALIA_COUNTRY_CODE = 'AU';
